import React, { useState } from 'react';

// The database only ever normalizes to these two customer names -
// see the master list normalization work. A button choice is simpler
// and faster than typing/searching when there are only two options.
// `id`/`name` is the exact customer_name value stored in the database -
// this is sent directly to /api/search as the `customer` field.
const MAKES = [
    { id: 'KENWORTH TRUCK COMPANY', name: 'KENWORTH TRUCK COMPANY', label: 'Kenworth' },
    { id: 'PETERBILT MOTORS CO.', name: 'PETERBILT MOTORS CO.', label: 'Peterbilt' }
];

function CustomerSearch({ onSelect }) {
    const [selectedId, setSelectedId] = useState(null);

    const handleSelect = (make) => {
        setSelectedId(make.id);
        onSelect(make);
    };

    return (
        <div className="customer-search">
            <label>Vehicle Make</label>
            <div className="make-buttons">
                {MAKES.map((make) => (
                    <button
                        key={make.id}
                        type="button"
                        className={`make-button${selectedId === make.id ? ' make-button-selected' : ''}`}
                        onClick={() => handleSelect(make)}
                    >
                        {make.label}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default CustomerSearch;